import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LinkHrisLocationToOpusLocationMutationVariables = Types.Exact<{
  groupId: Types.Scalars['Int']['input'];
  hrisLocationId: Types.Scalars['Int']['input'];
}>;


export type LinkHrisLocationToOpusLocationMutation = { __typename?: 'Mutation', createHrisLocationLink: { __typename?: 'GenericMutationResult', success: boolean } };


export const LinkHrisLocationToOpusLocationDocument = gql`
    mutation LinkHrisLocationToOpusLocation($groupId: Int!, $hrisLocationId: Int!) {
  createHrisLocationLink(groupId: $groupId, hrisLocationId: $hrisLocationId) {
    success
  }
}
    `;
export type LinkHrisLocationToOpusLocationMutationFn = Apollo.MutationFunction<LinkHrisLocationToOpusLocationMutation, LinkHrisLocationToOpusLocationMutationVariables>;

/**
 * __useLinkHrisLocationToOpusLocationMutation__
 *
 * To run a mutation, you first call `useLinkHrisLocationToOpusLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkHrisLocationToOpusLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkHrisLocationToOpusLocationMutation, { data, loading, error }] = useLinkHrisLocationToOpusLocationMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      hrisLocationId: // value for 'hrisLocationId'
 *   },
 * });
 */
export function useLinkHrisLocationToOpusLocationMutation(baseOptions?: Apollo.MutationHookOptions<LinkHrisLocationToOpusLocationMutation, LinkHrisLocationToOpusLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkHrisLocationToOpusLocationMutation, LinkHrisLocationToOpusLocationMutationVariables>(LinkHrisLocationToOpusLocationDocument, options);
      }
export type LinkHrisLocationToOpusLocationMutationHookResult = ReturnType<typeof useLinkHrisLocationToOpusLocationMutation>;
export type LinkHrisLocationToOpusLocationMutationResult = Apollo.MutationResult<LinkHrisLocationToOpusLocationMutation>;
export type LinkHrisLocationToOpusLocationMutationOptions = Apollo.BaseMutationOptions<LinkHrisLocationToOpusLocationMutation, LinkHrisLocationToOpusLocationMutationVariables>;